import { UpdateArrowCombinedProps } from './types';

const usePresenter = (props: UpdateArrowCombinedProps): UpdateArrowCombinedProps => {
  return props;
};

export default usePresenter;
